import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { Select } from 'foundations-components/transitional/components/Select';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { virtualizedMenuRenderer } from 'foundations-components/transitional/utils/virtualizedMenuRenderer';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getTimezoneGroupSelectOptions } from '../../utils/timezoneUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimezoneEditor = ({
  tz,
  setTZ,
  tzAutoUpdateEnabled,
  setTzAutoUpdateEnabled,
  showTzAutoUpdateCheckbox
}) => {
  const tzList = getTimezoneGroupSelectOptions();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Select, {
      "data-test-id": "timezone-select",
      marginBlockStart: "400",
      marginBlockEnd: "100",
      onChange: ({
        target: {
          value
        }
      }) => {
        setTZ(value);
      },
      value: tz,
      options: tzList
      // Timezone is determined by location in this case
      ,
      disabled: tzAutoUpdateEnabled,
      menuRenderer: virtualizedMenuRenderer
    }), showTzAutoUpdateCheckbox && /*#__PURE__*/_jsx(Checkbox, {
      "data-test-id": "timezone-auto-update-checkbox",
      "data-test-value": tzAutoUpdateEnabled,
      checked: tzAutoUpdateEnabled,
      onChange: ({
        target: {
          checked
        }
      }) => setTzAutoUpdateEnabled(checked),
      description: /*#__PURE__*/_jsx(HelpIcon, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ui-asset-management-lib.timezoneModal.timezoneAutoUpdate.helperText"
        })
      }),
      descriptionLayout: "horizontal",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-asset-management-lib.timezoneModal.timezoneAutoUpdate.label"
      })
    })]
  });
};
export default TimezoneEditor;